<div class="mx-auto w-[90%]">
  <div class="mb-6 mt-10 flex justify-between text-center">
    <h1 class="text-start text-3xl font-bold">SEPA</h1>
    <div class="flex gap-4" *ngIf="!!sepaData">
      <ng-container *ngIf="!isEditMode">
        <button
          *ngIf="sepaData.validado"
          (click)="toggleContabilidadDropdown()"
          class="btn relative flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono opciones" fontIcon="account_balance_wallet" />
          Contabilidad

          <div *ngIf="isContabilidadDropdownOpen" class="dropdown-menu mt-5">
            <button
              (click)="exportarContabilidadExcel()"
              class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
            >
              <mat-icon aria-hidden="false" aria-label="icono exportar gasto" fontIcon="download" />
              Exportar a Excel
            </button>
            <button
              (click)="exportarContabilidadCsv()"
              class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
            >
              <mat-icon aria-hidden="false" aria-label="icono exportar gasto" fontIcon="download" />
              Exportar a CSV
            </button>
          </div>
        </button>
        <button
          (click)="toggleRemesaDropdown()"
          class="btn relative flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono opciones" fontIcon="account_balance" />
          Remesa

          <div *ngIf="isRemesaDropdownOpen" class="dropdown-menu mt-5">
            <button
              (click)="exportarRemesaExcel()"
              class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
            >
              <mat-icon aria-hidden="false" aria-label="icono exportar gasto" fontIcon="download" />
              Exportar a Excel
            </button>
            <button
              (click)="exportarRemesaCsv()"
              class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
            >
              <mat-icon aria-hidden="false" aria-label="icono exportar gasto" fontIcon="download" />
              Exportar a CSV
            </button>
          </div>
        </button>
        <button
          *ngIf="!sepaData?.validado"
          (click)="toggleEdit()"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar gasto" fontIcon="edit" />
          Editar
        </button>
        <button
          *ngIf="!sepaData?.validado"
          (click)="mostrarDiaologoEliminar = true"
          class="btn hover:medium-alert flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-alert bg-alert px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono eliminar" fontIcon="delete" />
          Eliminar
        </button>
        <button
          *ngIf="!sepaData?.validado"
          (click)="mostrarDialogoValidacion = true"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar gasto" fontIcon="check" />
          Validar Sepa
        </button>
        <button
          *ngIf="sepaData?.validado"
          class="btn hover:disabled flex h-fit cursor-default items-center justify-center gap-2 rounded-lg border-2 border-blue bg-blue px-4 py-2 text-seasalt transition delay-100 ease-in"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar gasto" fontIcon="check" />
          Remesa Validada
        </button>

        <button
          *ngIf="sepaData?.validado && !sepaData?.validadoContabilidad"
          (click)="mostrarDialogoValidacionContabilidad = true"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar gasto" fontIcon="check" />
          Validar Contabilidad Sepa
        </button>
        <button
          *ngIf="sepaData?.validado && sepaData?.validadoContabilidad"
          class="btn hover:disabled flex h-fit cursor-default items-center justify-center gap-2 rounded-lg border-2 border-blue bg-blue px-4 py-2 text-seasalt transition delay-100 ease-in"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar gasto" fontIcon="check" />
          Contabilidad Validada
        </button>
        <button
          *ngIf="sepaData?.validado && !sepaData?.hasVenta"
          (click)="mostrarDiaologoGenerarVenta = true"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono pagado" fontIcon="credit_card_gear" />
          Generar Venta
        </button>
        <button
          *ngIf="sepaData?.validado && sepaData?.hasVenta"
          (click)="goToVenta()"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono ir a venta" fontIcon="exit_to_app" />
          Ir a Venta
        </button>
      </ng-container>
      <ng-container *ngIf="isEditMode">
        <app-loading-button
          [text]="'Guardar'"
          [icon]="'save'"
          [loading]="isLoading"
          [disabled]="sepaForm.invalid || sepaForm.pending"
          (clicked)="guardarCambios()"
        />
        <button
          (click)="cancelarEdicion()"
          class="btn flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-alert bg-alert px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-alert hover:bg-seasalt hover:text-alert"
        >
          <mat-icon aria-hidden="false" aria-label="icono cancelar edición" fontIcon="cancel" />
          Cancelar
        </button>
      </ng-container>
    </div>
  </div>

  <form *ngIf="!!sepaForm" [formGroup]="sepaForm" class="mx-auto mb-32 w-[100%] space-y-6">
    <div class="card-shadow space-y-4 rounded-md p-4">
      <h2 class="mb-4 text-2xl font-semibold text-field-green">Datos de la remesa</h2>
      <div class="grid grid-cols-3 gap-4 rounded-md bg-seasalt">
        <!-- FECHA GENERACION -->
        <div>
          <app-input-fecha
            [formGroup]="sepaForm"
            controlName="fechaGeneracionSepa"
            label="Fecha de generación de la remesa"
          />
        </div>
        <!-- PROVEEDOR -->
        <div>
          <label for="empresaFacturadoraId" class="block text-sm font-medium">Empresa</label>
          <select
            id="empresaFacturadoraId"
            formControlName="empresaFacturadoraId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let empresa of empresasRefacturadoras" [value]="empresa.id">
              {{ empresa.nombreEmpresa }}
            </option>
          </select>
          <app-form-errors fieldName="empresaFacturadoraId" />
        </div>
        <!-- CUENTA BANCARIA -->
        <div>
          <label for="cuentaBancariaId" class="block text-sm font-medium">Cuenta bancaria</label>
          <select
            id="cuentaBancariaId"
            formControlName="cuentaBancariaId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let cuenta of cuentasBancarias" [value]="cuenta.id">
              {{ cuenta.banco }} - {{ cuenta.numeroCuenta }}
            </option>
          </select>
          <app-form-errors fieldName="cuentaBancariaId" />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-4 rounded-md bg-seasalt">
        <div>
          <app-input-fecha [formGroup]="sepaForm" controlName="fechaValidacion" label="Fecha de Validación" />
        </div>
        <div>
          <app-input-fecha [formGroup]="sepaForm" controlName="fechaEmision" label="Fecha de emisión de las facturas" />
        </div>
        <div>
          <app-input-fecha [formGroup]="sepaForm" controlName="fechaCargo" label="Fecha de cargo al cliente" />
        </div>
      </div>
      <div *ngIf="sepaData.validado && !sepaData.validadoContabilidad" class="mt-4 grid grid-cols-3 gap-4">
        <app-input-number [formGroup]="sepaForm" controlName="codAlbaran" label="Código Albarán" />
        <div *ngIf="sepaData.validado && !sepaData.validadoContabilidad">
          <label class="block text-sm font-medium">&nbsp;</label>
          <button
            (click)="abrirModal('modalCambiarCodigoAlbaran')"
            class="btn flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
          >
            <mat-icon aria-hidden="false" aria-label="icono cambiar código albarán" fontIcon="edit" />
            Cambiar Código Albarán
          </button>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4">
        <app-input-textarea label="Observaciones de SEPA" [formGroup]="sepaForm" controlName="observaciones" />
      </div>
    </div>
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-4 text-xl font-semibold text-field-green">Facturas Seleccionables</h2>

      <div class="mt-4">
        <app-form-errors class="mb-2" fieldName="facturas" />
        <ag-grid-angular
          style="min-width: 100%; height: 75vh"
          class="ag-theme-quartz mx-auto"
          [rowData]="sepaData.facturas"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
        />
      </div>
    </div>
  </form>
</div>

<app-async-confirmation-dialog
  [isOpen]="mostrarDialogoValidacion"
  [title]="'Validar Remesa Sepa'"
  [message]="
    'La remesa Sepa sera validada. Esta acción enviará todas las facturas correspondientes a la remesa a los clientes.'
  "
  [confirmButtonText]="'Validar Remesa Sepa'"
  [confirmButtonIcon]="'check'"
  [loading]="isLoadingValidar"
  (closed)="mostrarDialogoValidacion = false"
  (confirmed)="validarRemesaSepa()"
/>

<app-async-confirmation-dialog
  [isOpen]="mostrarDialogoValidacionContabilidad"
  [title]="'Validar Contabilidad Sepa'"
  [message]="'La contabilidad Sepa sera validada.'"
  [confirmButtonText]="'Validar Contabilidad Sepa'"
  [confirmButtonIcon]="'check'"
  [loading]="isLoadingValidarContabilidad"
  (closed)="mostrarDialogoValidacionContabilidad = false"
  (confirmed)="validarContabilidadSepa()"
/>

<app-async-confirmation-dialog
  [isOpen]="mostrarDiaologoGenerarVenta"
  [title]="'Generar Venta'"
  [message]="'¿Está seguro de que desea generar esta venta?'"
  [confirmButtonText]="'Generar Venta'"
  [confirmButtonIcon]="'credit_card_gear'"
  [loading]="isLoadingGenerarVenta"
  (closed)="mostrarDiaologoGenerarVenta = false"
  (confirmed)="generarVenta()"
/>

<app-async-confirmation-dialog
  [isOpen]="mostrarDiaologoEliminar"
  [title]="'Eliminar Sepa'"
  [message]="'¿Está seguro de que desea eliminar este sepa?'"
  [confirmButtonText]="'Eliminar'"
  [confirmButtonIcon]="'delete'"
  [isDeleteAction]="true"
  [loading]="isLoadingEliminar"
  (closed)="mostrarDiaologoEliminar = false"
  (confirmed)="eliminarSepa()"
/>

<!-- MODAL CAMBIAR CODIGO ALBARAN -->
<dialog
  id="modalCambiarCodigoAlbaran"
  class="bg-medium-yellow fixed left-1/2 top-1/2 mx-4 max-h-[80vh] w-4/5 max-w-3xl -translate-x-1/2 -translate-y-1/2 transform rounded-3xl p-6 md:mx-0"
>
  <div class="relative flex flex-col items-center justify-center gap-4">
    <div class="flex w-full items-center justify-between">
      <h2 class="my-3 self-start px-6 text-3xl font-bold text-field-green">Cambiar Código Albarán</h2>
      <div class="sticky right-3 top-0 z-10 flex justify-end">
        <button
          (click)="cerrarModal('modalCambiarCodigoAlbaran')"
          class="btn flex items-center justify-center rounded-xl border-2 border-medium-green bg-medium-green px-2 py-2 text-lg text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon fontIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <div
      id="contenidoPagarEfectivo"
      class="mb-4 flex w-full flex-col items-center justify-center gap-4 rounded-3xl bg-dark-blue py-6 font-semibold text-seasalt"
    >
      <p>Indique el nuevo código de albarán inicial para este gasto:</p>
      <div>
        <input
          [id]="nuevoCodigoAlbaran"
          [(ngModel)]="nuevoCodigoAlbaran"
          type="number"
          step="1"
          value="sepaData?.codAlbaran"
          class="border-1 form-input mt-1 block w-full rounded-md border-dark-blue text-alert shadow-sm focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
        />
      </div>
      <p>¿Desea proseguir con la operación?</p>
    </div>
    <div>
      <app-loading-button
        [text]="'Cambiar Código Albarán'"
        [icon]="'reply'"
        [loading]="isLoadingCambiarCodigoAlbaran"
        [disabled]="!nuevoCodigoAlbaran || nuevoCodigoAlbaran === sepaData.codAlbaran"
        (clicked)="cambiarCodigoAlbaran()"
      />
    </div>
  </div>
</dialog>
